import { render, staticRenderFns } from "./Triase.vue?vue&type=template&id=f90bf458&scoped=true"
import script from "./Triase.vue?vue&type=script&lang=js"
export * from "./Triase.vue?vue&type=script&lang=js"
import style0 from "./Triase.vue?vue&type=style&index=0&id=f90bf458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90bf458",
  null
  
)

export default component.exports